import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import Actions from './actions';
var Types = Actions.Types;
var INITIAL_STATE = {
  partySize: 2,
  firstName: '',
  lastName: '',
  emailAddress: '',
  phoneNumber: '',
  zipCode: '',
  newsletter: false,
  err: {},
  results: [],
  isError: false,
  isLoading: false,
  waitlistActive: false,
  waitlistAvailable: false,
  confirmation: null,
  confirmationNumber: null,
  storeId: null,
  oloId: null,
  showForm: true,
  checkedIn: false,
  isUserAtRestaurant: undefined,
  showWaitListModal: false
};

var waitlistReducer = function waitlistReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Types.TOGGLE_WAITLIST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          waitlistActive: !state.waitlistActive,
          secondaryNavVisible: false
        });
      }

    case Types.CHANGE_INPUT:
      {
        return _objectSpread(_objectSpread({}, state), action);
      }

    case Types.REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true
        });
      }

    case Types.RESPONSE:
      {
        var results = action.results,
            storeId = action.storeId;
        return _objectSpread(_objectSpread({}, state), {}, {
          results: results,
          checkedIn: (results === null || results === void 0 ? void 0 : results.ConfirmationNumber) ? false : true,
          confirmation: results.ID,
          confirmationNumber: results.ConfirmationNumber,
          storeId: storeId,
          showForm: false,
          isLoading: false,
          isError: false,
          err: null
        });
      }

    case Types.STATUS:
      {
        var _results = action.results;
        return _objectSpread(_objectSpread({}, state), {}, {
          results: _results,
          isLoading: false,
          err: null
        });
      }

    case Types.TOGGLE_FORM:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          showForm: !state.showForm
        });
      }

    case Types.CANCEL:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          waitlistActive: false,
          results: [],
          showForm: true,
          confirmation: null,
          storeId: null,
          isLoading: false,
          partySize: 2,
          firstName: '',
          lastName: '',
          emailAddress: '',
          phoneNumber: '',
          zipCode: '',
          checkedIn: false,
          isUserAtRestaurant: undefined
        });
      }

    case 'WAITLIST_TOGGLE_WAITLIST_CHECK_IN_MODAL':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          showWaitListModal: (action === null || action === void 0 ? void 0 : action.show) == null ? !state.showWaitListModal : action === null || action === void 0 ? void 0 : action.show
        });
      }

    case Types.CHECKIN:
      {
        var checkedIn = action.checkedIn,
            isUserAtRestaurant = action.isUserAtRestaurant;
        return _objectSpread(_objectSpread({}, state), {}, {
          checkedIn: checkedIn,
          showForm: checkedIn ? false : true,
          isUserAtRestaurant: isUserAtRestaurant
        });
      }

    case Types.RESET:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false
        });
      }

    default:
      {
        return state;
      }
  }
};

export default waitlistReducer;